import axios from 'axios';

import {
    IMPLANT_INSTANCE_LIST_REQUEST,
    IMPLANT_INSTANCE_LIST_SUCCESS,
    IMPLANT_INSTANCE_LIST_FAIL,

    IMPLANT_INSTANCE_DETAILS_REQUEST,
    IMPLANT_INSTANCE_DETAILS_SUCCESS,
    IMPLANT_INSTANCE_DETAILS_FAIL,

    IMPLANT_INSTANCE_DELETE_REQUEST,
    IMPLANT_INSTANCE_DELETE_SUCCESS,
    IMPLANT_INSTANCE_DELETE_FAIL,

    IMPLANT_INSTANCE_CREATE_REQUEST,
    IMPLANT_INSTANCE_CREATE_SUCCESS,
    IMPLANT_INSTANCE_CREATE_FAIL,

    IMPLANT_INSTANCE_UPDATE_REQUEST,
    IMPLANT_INSTANCE_UPDATE_SUCCESS,
    IMPLANT_INSTANCE_UPDATE_FAIL,

    IMPLANT_INSTANCE_REQUEST,
    IMPLANT_INSTANCE_FAIL,
    IMPLANT_INSTANCE_RESET,
    IMPLANT_INSTANCE_SUCCESS,

    IMPLANT_INSTANCE_COUNT_SUCCESS,
    IMPLANT_INSTANCE_COUNT_REQUEST,
    IMPLANT_INSTANCE_COUNT_FAIL,

    IMPLANT_INSTANCE_LIST_BY_PATIENT_ID_REQUEST,
    IMPLANT_INSTANCE_LIST_BY_PATIENT_ID_SUCCESS,
    IMPLANT_INSTANCE_LIST_BY_PATIENT_ID_FAIL,

    SET_CURRENT_PAGE,
    

} from "../constants/implantInstanceConstants";

// use dispatch to dispatch the request and throw it into the reducer
export const listImplantInstances = (filter) => async (dispatch, getState) => {
    try {
        dispatch({ type: IMPLANT_INSTANCE_LIST_REQUEST });
        const {
            userLogin: { userInfo },
        } = getState();

        let params = {};
        // get the filter
        if (filter) {
            params = filter;
        }

        const config = {
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            },
            params
        }
        const { data } = await axios.get('/api/v1/implantInstance/all', config);

        dispatch({
            type: IMPLANT_INSTANCE_LIST_SUCCESS,
            payload: data
        });


    } catch (error) {
        let errorMessages = [];
        if (error.response && error.response.data) {
            // Check if 'errors' object exists
            if (error.response.data.errors) {
                // Loop through 'errors' object and construct error message
                for (const [key, value] of Object.entries(error.response.data.errors)) {
                    errorMessages.push(`${key}: ${value[0]} `);
                }
            }
            // Check if 'detail' field exists
            if (error.response.data.detail) {
                errorMessages.push(`Detail: ${error.response.data.detail} `);
            }
            // check if 'message' field exists
            if (error.response.data.message) {
                errorMessages.push(`Message: ${error.response.data.message} `);
            }
        } else {
            errorMessages.push(error.message);
        }

        dispatch({
            type: IMPLANT_INSTANCE_LIST_FAIL,
            payload: errorMessages,
        });
    }
}

// get implantInstances by patientNhsNumber
export const listImplantInstancesByPatientNhsNumber = (patientNhsNumber) => async (dispatch, getState) => {
    try {
        dispatch({ type: IMPLANT_INSTANCE_LIST_REQUEST });
        const {
            userLogin: { userInfo },
        } = getState();

        let params = {};

        const config = {
            headers: {
                'Content-type': 'application/json',
                ...(userInfo?.token && { Authorization: `Bearer ${userInfo.token}` }),
            },
            params
        }
        const { data } = await axios.get(`/api/v1/implantInstance/all/${patientNhsNumber}`, config);

        dispatch({
            type: IMPLANT_INSTANCE_LIST_SUCCESS,
            payload: data
        });

    } catch (error) {
        let errorMessages = [];
        if (error.response && error.response.data) {
            // Check if 'errors' object exists
            if (error.response.data.errors) {
                // Loop through 'errors' object and construct error message
                for (const [key, value] of Object.entries(error.response.data.errors)) {
                    errorMessages.push(`${key}: ${value[0]} `);
                }
            }
            // Check if 'detail' field exists
            if (error.response.data.detail) {
                errorMessages.push(`Detail: ${error.response.data.detail} `);
            }
            // check if 'message' field exists
            if (error.response.data.message) {
                errorMessages.push(`Message: ${error.response.data.message} `);
            }
        }
        else {
            errorMessages.push(error.message);
        }

        dispatch({
            type: IMPLANT_INSTANCE_LIST_FAIL,
            payload: errorMessages,
        });
    }
}

// get implantInstances by patientId
export const listImplantInstancesByPatientId = (patientId) => async (dispatch, getState) => {
    try {
        dispatch({ type: IMPLANT_INSTANCE_LIST_BY_PATIENT_ID_REQUEST });
        const {
            userLogin: { userInfo },
        } = getState();

        let params = {};

        const config = {
            headers: {
                'Content-type': 'application/json',
                ...(userInfo?.token && { Authorization: `Bearer ${userInfo.token}` }),
            },
            params
        }
        const { data } = await axios.get(`/api/v1/implantInstance/patient/${patientId}`, config);

        dispatch({
            type: IMPLANT_INSTANCE_LIST_BY_PATIENT_ID_SUCCESS,
            payload: data
        });

    } catch (error) {
        let errorMessages = [];
        if (error.response && error.response.data) {
            // Check if 'errors' object exists
            if (error.response.data.errors) {
                // Loop through 'errors' object and construct error message
                for (const [key, value] of Object.entries(error.response.data.errors)) {
                    errorMessages.push(`${key}: ${value[0]} `);
                }
            }
            // Check if 'detail' field exists
            if (error.response.data.detail) {
                errorMessages.push(`Detail: ${error.response.data.detail} `);
            }
            // check if 'message' field exists
            if (error.response.data.message) {
                errorMessages.push(`Message: ${error.response.data.message} `);
            }
        }
        else {
            errorMessages.push(error.message);
        }

        dispatch({
            type: IMPLANT_INSTANCE_LIST_BY_PATIENT_ID_FAIL,
            payload: errorMessages,
        });
    }
}

// count implantInstances
export const countImplantInstances = () => async (dispatch, getState) => {
    try {
      dispatch({ type: IMPLANT_INSTANCE_COUNT_REQUEST });
      const {
        userLogin: { userInfo },
      } = getState();
  
      const config = {
        headers: {
          'Content-type': 'application/json',
          Authorization: `Bearer ${userInfo.token}`
        },
      }
      const { data } = await axios.get('/api/v1/implantInstance/count', config);
  
      dispatch({
        type: IMPLANT_INSTANCE_COUNT_SUCCESS,
        payload: data
      });
    } catch (error) {
      dispatch({
        type: IMPLANT_INSTANCE_COUNT_FAIL,
        payload: error.response && error.response.data.detail
            ? error.response.data.detail
            : "Failed to fetch implantInstance counts",
      });
    }
  }
  


export const getImplantInstanceDetails = (_id) => async (dispatch, getState) => {
    try {
        dispatch({ type: IMPLANT_INSTANCE_DETAILS_REQUEST });
        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        }
        const { data } = await axios.get(`/api/v1/implantInstance/${_id}`, config);

        dispatch({
            type: IMPLANT_INSTANCE_DETAILS_SUCCESS,
            payload: data
        });

    } catch (error) {
        let errorMessages = [];
        if (error.response && error.response.data) {
            // Check if 'errors' object exists
            if (error.response.data.errors) {
                // Loop through 'errors' object and construct error message
                for (const [key, value] of Object.entries(error.response.data.errors)) {
                    errorMessages.push(`${key}: ${value[0]} `);
                }
            }
            // Check if 'detail' field exists
            if (error.response.data.detail) {
                errorMessages.push(`Detail: ${error.response.data.detail} `);
            }
            // check if 'message' field exists
            if (error.response.data.message) {
                errorMessages.push(`Message: ${error.response.data.message} `);
            }
        } else {
            errorMessages.push(error.message);
        }

        dispatch({
            type: IMPLANT_INSTANCE_DETAILS_FAIL,
            payload: errorMessages,
        });
    }
}

export const deleteImplantInstance = (_id) => async (dispatch, getState) => {
    try {
        dispatch({
            type: IMPLANT_INSTANCE_DELETE_REQUEST
        })

        const {
            userLogin: { userInfo },
        } = getState()

        const config = {
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        }

        const { data } = await axios.delete(
            `/api/v1/implantInstance/${_id}/`,
            config
        )

        dispatch({
            type: IMPLANT_INSTANCE_DELETE_SUCCESS,
        })


    } catch (error) {
        let errorMessages = [];
        if (error.response && error.response.data) {
            // Check if 'errors' object exists
            if (error.response.data.errors) {
                // Loop through 'errors' object and construct error message
                for (const [key, value] of Object.entries(error.response.data.errors)) {
                    errorMessages.push(`${key}: ${value[0]} `);
                }
            }
            // Check if 'detail' field exists
            if (error.response.data.detail) {
                errorMessages.push(`Detail: ${error.response.data.detail} `);
            }
            // check if 'message' field exists
            if (error.response.data.message) {
                errorMessages.push(`Message: ${error.response.data.message} `);
            }
        } else {
            errorMessages.push(error.message);
        }
        dispatch({
            type: IMPLANT_INSTANCE_DELETE_FAIL,
            payload: errorMessages,
        })
    }
}

export const createImplantInstance = (changes) => async (dispatch, getState) => {
    try {
        dispatch({
            type: IMPLANT_INSTANCE_CREATE_REQUEST
        })

        const {
            userLogin: { userInfo },
        } = getState()

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        }

        const data = await axios.post(
            `/api/v1/implantInstance/`,
            changes,
            config
        )

        dispatch({
            type: IMPLANT_INSTANCE_CREATE_SUCCESS,
            payload: data,
        })


    } catch (error) {
        let errorMessages = [];
        if (error.response && error.response.data) {
            // Check if 'errors' object exists
            if (error.response.data.errors) {
                // Loop through 'errors' object and construct error message
                for (const [key, value] of Object.entries(error.response.data.errors)) {
                    errorMessages.push(`${key}: ${value[0]} `);
                }
            }
            // Check if 'detail' field exists
            if (error.response.data.detail) {
                errorMessages.push(`Detail: ${error.response.data.detail} `);
            }
            // check if 'message' field exists
            if (error.response.data.message) {
                errorMessages.push(`Message: ${error.response.data.message} `);
            }
        } else {
            errorMessages.push(error.message);
        }

        dispatch({
            type: IMPLANT_INSTANCE_CREATE_FAIL,
            payload: errorMessages,
        })
    }
}
const loadImplantInstanceBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            const base64String = reader.result.split(',')[1];
            resolve(base64String);
        };
        reader.onerror = (error) => reject(error);
    });
};

// make implantInstance using a local implantInstance
export const makeImplantInstance = (file, implantInstanceId, apiEndPoint, apiKey) => async (dispatch, getState) => {

    const implantInstance = await loadImplantInstanceBase64(file);
    const implantInstance_input = JSON.stringify({ "implantInstance": implantInstance });
    const {
        userLogin: { userInfo },
    } = getState()

    const config = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${userInfo.token}`
        }
    }

    const data = await axios.post(
        apiEndPoint,
        implantInstance_input,
        config
    )
    try {
        dispatch({
            type: IMPLANT_INSTANCE_RESET
        })
        await axios({
            method: "POST",
            url: apiEndPoint,

            data: JSON.stringify({ "data": implantInstance }),
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${userInfo.token}`
            },
        }).then((response) => {
                dispatch({
                    type: IMPLANT_INSTANCE_SUCCESS
                });
                if (implantInstanceId && response.data) {
                    dispatch(updateImplantInstance(implantInstanceId, { implantInstance: response.data }));
                }
            })
            .catch(function (error) {
                dispatch({
                    type: IMPLANT_INSTANCE_FAIL
                });
                console.log(error.message);
            });
    }

    catch (error) {
        dispatch({
            type: IMPLANT_INSTANCE_FAIL,
            payload: error.response && error.response.data.detail
                ? error.response.data.detail
                : error.message,
        })
    }

}


export const updateImplantInstance = (_id, changes) => async (dispatch, getState) => {
    try {
        dispatch({
            type: IMPLANT_INSTANCE_UPDATE_REQUEST
        });

        const {
            userLogin: { userInfo },
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        };

        const response = await axios.patch(
            `/api/v1/implantInstance/${_id}/`,
            changes,
            config
        );

        dispatch({
            type: IMPLANT_INSTANCE_UPDATE_SUCCESS,
            payload: response.data, // Assuming the updated implantInstance data is returned
        });

        dispatch({
            type: IMPLANT_INSTANCE_DETAILS_SUCCESS,
            payload: response.data, // Assuming the updated implantInstance data is returned
        });
    } catch (error) {
        let errorPayload = [];

        if (error.response && error.response.status === 400 && error.response.data.errors) {
            const validationErrors = error.response.data.errors;
            // Concatenate detailed validation errors to the error payload array
            errorPayload = Object.values(validationErrors).flat();
        }

        // Include generic error message or additional error data in the payload array
        if (error.response && error.response.data.detail) {
            errorPayload.push(error.response.data.detail);
        } else {
            errorPayload.push(error.message);
        }

        dispatch({
            type: IMPLANT_INSTANCE_UPDATE_FAIL,
            payload: errorPayload,
        });
    }
};
